"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * PlumbingWorld-3.0
 * PlumbingWorld API
 *
 * Contact: jspencer@juliusspencer.co.nz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var OrderApi = /** @class */ (function (_super) {
    __extends(OrderApi, _super);
    function OrderApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Attempt to approve price overrides for an order
     */
    OrderApi.prototype.approvePriceOverridesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/retail/priceOverride/approvePricing",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.ApprovePriceOverridesRequestToJSON(requestParameters.approvePriceOverridesRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ApprovePriceOverridesResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Attempt to approve price overrides for an order
     */
    OrderApi.prototype.approvePriceOverrides = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.approvePriceOverridesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create an order for a user
     */
    OrderApi.prototype.createOrderRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.createOrder === null || requestParameters.createOrder === undefined) {
                            throw new runtime.RequiredError('createOrder', 'Required parameter requestParameters.createOrder was null or undefined when calling createOrder.');
                        }
                        queryParameters = {};
                        if (requestParameters.printerAddress !== undefined) {
                            queryParameters['printerAddress'] = requestParameters.printerAddress;
                        }
                        if (requestParameters.printDocket !== undefined) {
                            queryParameters['printDocket'] = requestParameters.printDocket;
                        }
                        if (requestParameters.printDocketWithPrice !== undefined) {
                            queryParameters['printDocketWithPrice'] = requestParameters.printDocketWithPrice;
                        }
                        if (requestParameters.printDocketWithRetailPrice !== undefined) {
                            queryParameters['printDocketWithRetailPrice'] = requestParameters.printDocketWithRetailPrice;
                        }
                        if (requestParameters.labelPrinterAddress !== undefined) {
                            queryParameters['labelPrinterAddress'] = requestParameters.labelPrinterAddress;
                        }
                        if (requestParameters.printOrderLabels !== undefined) {
                            queryParameters['printOrderLabels'] = requestParameters.printOrderLabels;
                        }
                        if (requestParameters.orderLabelQuantity !== undefined) {
                            queryParameters['orderLabelQuantity'] = requestParameters.orderLabelQuantity;
                        }
                        if (requestParameters.invoiceOrder !== undefined) {
                            queryParameters['invoiceOrder'] = requestParameters.invoiceOrder;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_order"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/order",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.CreateOrderToJSON(requestParameters.createOrder),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.OrderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create an order for a user
     */
    OrderApi.prototype.createOrder = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createOrderRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Downloads an order or a quote
     */
    OrderApi.prototype.downloadOrderRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling downloadOrder.');
                        }
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling downloadOrder.');
                        }
                        if (requestParameters.orderSuffixId === null || requestParameters.orderSuffixId === undefined) {
                            throw new runtime.RequiredError('orderSuffixId', 'Required parameter requestParameters.orderSuffixId was null or undefined when calling downloadOrder.');
                        }
                        if (requestParameters.orderType === null || requestParameters.orderType === undefined) {
                            throw new runtime.RequiredError('orderType', 'Required parameter requestParameters.orderType was null or undefined when calling downloadOrder.');
                        }
                        queryParameters = {};
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.orderType !== undefined) {
                            queryParameters['orderType'] = requestParameters.orderType;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_order"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/orders/{orderId}/{orderSuffixId}/download".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))).replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))).replace("{" + "orderSuffixId" + "}", encodeURIComponent(String(requestParameters.orderSuffixId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads an order or a quote
     */
    OrderApi.prototype.downloadOrder = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadOrderRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Downloads orders as a zip
     */
    OrderApi.prototype.downloadOrdersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling downloadOrders.');
                        }
                        if (requestParameters.orderType === null || requestParameters.orderType === undefined) {
                            throw new runtime.RequiredError('orderType', 'Required parameter requestParameters.orderType was null or undefined when calling downloadOrders.');
                        }
                        queryParameters = {};
                        if (requestParameters.orderType !== undefined) {
                            queryParameters['orderType'] = requestParameters.orderType;
                        }
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/customer/{customerId}/orders/download".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.DownloadOrdersRequestToJSON(requestParameters.downloadOrdersRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads orders as a zip
     */
    OrderApi.prototype.downloadOrders = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadOrdersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Downloads the selected orders from a server generated download link
     */
    OrderApi.prototype.downloadOrdersByLinkRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling downloadOrdersByLink.');
                        }
                        if (requestParameters.token === null || requestParameters.token === undefined) {
                            throw new runtime.RequiredError('token', 'Required parameter requestParameters.token was null or undefined when calling downloadOrdersByLink.');
                        }
                        if (requestParameters.orderType === null || requestParameters.orderType === undefined) {
                            throw new runtime.RequiredError('orderType', 'Required parameter requestParameters.orderType was null or undefined when calling downloadOrdersByLink.');
                        }
                        if (requestParameters.type === null || requestParameters.type === undefined) {
                            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling downloadOrdersByLink.');
                        }
                        if (requestParameters.orders === null || requestParameters.orders === undefined) {
                            throw new runtime.RequiredError('orders', 'Required parameter requestParameters.orders was null or undefined when calling downloadOrdersByLink.');
                        }
                        queryParameters = {};
                        if (requestParameters.token !== undefined) {
                            queryParameters['token'] = requestParameters.token;
                        }
                        if (requestParameters.orderType !== undefined) {
                            queryParameters['orderType'] = requestParameters.orderType;
                        }
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.orders !== undefined) {
                            queryParameters['orders'] = requestParameters.orders;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/link/user/admin/customer/{customerId}/order/download".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads the selected orders from a server generated download link
     */
    OrderApi.prototype.downloadOrdersByLink = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadOrdersByLinkRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Emails selected orders (if multiple orders, attachments will be zipped)
     */
    OrderApi.prototype.emailOrdersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling emailOrders.');
                        }
                        if (requestParameters.orderType === null || requestParameters.orderType === undefined) {
                            throw new runtime.RequiredError('orderType', 'Required parameter requestParameters.orderType was null or undefined when calling emailOrders.');
                        }
                        if (requestParameters.type === null || requestParameters.type === undefined) {
                            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling emailOrders.');
                        }
                        queryParameters = {};
                        if (requestParameters.orderType !== undefined) {
                            queryParameters['orderType'] = requestParameters.orderType;
                        }
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/admin/customer/{customerId}/orders/email".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.EmailOrdersRequestToJSON(requestParameters.emailOrdersRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Emails selected orders (if multiple orders, attachments will be zipped)
     */
    OrderApi.prototype.emailOrders = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.emailOrdersRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get customer order
     */
    OrderApi.prototype.getCustomerOrderRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getCustomerOrder.');
                        }
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling getCustomerOrder.');
                        }
                        if (requestParameters.orderSuffixId === null || requestParameters.orderSuffixId === undefined) {
                            throw new runtime.RequiredError('orderSuffixId', 'Required parameter requestParameters.orderSuffixId was null or undefined when calling getCustomerOrder.');
                        }
                        queryParameters = {};
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_order"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/customer/{customerId}/orders/{orderId}/{orderSuffixId}".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))).replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))).replace("{" + "orderSuffixId" + "}", encodeURIComponent(String(requestParameters.orderSuffixId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CustomerOrderResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get customer order
     */
    OrderApi.prototype.getCustomerOrder = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerOrderRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get customer orders
     */
    OrderApi.prototype.getCustomerOrdersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getCustomerOrders.');
                        }
                        if (requestParameters.type === null || requestParameters.type === undefined) {
                            throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling getCustomerOrders.');
                        }
                        queryParameters = {};
                        if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                        }
                        if (requestParameters.dateFrom !== undefined) {
                            queryParameters['dateFrom'] = requestParameters.dateFrom;
                        }
                        if (requestParameters.dateTo !== undefined) {
                            queryParameters['dateTo'] = requestParameters.dateTo;
                        }
                        if (requestParameters.branchId !== undefined) {
                            queryParameters['branchId'] = requestParameters.branchId;
                        }
                        if (requestParameters.salesRep !== undefined) {
                            queryParameters['salesRep'] = requestParameters.salesRep;
                        }
                        if (requestParameters.reference !== undefined) {
                            queryParameters['reference'] = requestParameters.reference;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        if (requestParameters.pwgoOnly !== undefined) {
                            queryParameters['pwgoOnly'] = requestParameters.pwgoOnly;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        if (requestParameters.transactionNumber !== undefined) {
                            queryParameters['transactionNumber'] = requestParameters.transactionNumber;
                        }
                        if (requestParameters.interimOrders !== undefined) {
                            queryParameters['interimOrders'] = requestParameters.interimOrders;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_order"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/customer/{customerId}/orders".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.CustomerOrdersResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get customer orders
     */
    OrderApi.prototype.getCustomerOrders = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerOrdersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get fixed locations for provided branch id
     */
    OrderApi.prototype.getFixedLocationsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.branchId === null || requestParameters.branchId === undefined) {
                            throw new runtime.RequiredError('branchId', 'Required parameter requestParameters.branchId was null or undefined when calling getFixedLocations.');
                        }
                        queryParameters = {};
                        if (requestParameters.branchId !== undefined) {
                            queryParameters['branchId'] = requestParameters.branchId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/retail/fixedLocations",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.FixedLocationsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get fixed locations for provided branch id
     */
    OrderApi.prototype.getFixedLocations = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getFixedLocationsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get job contracts for provided customer id and branch id
     */
    OrderApi.prototype.getJobContractsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getJobContracts.');
                        }
                        if (requestParameters.branchId === null || requestParameters.branchId === undefined) {
                            throw new runtime.RequiredError('branchId', 'Required parameter requestParameters.branchId was null or undefined when calling getJobContracts.');
                        }
                        queryParameters = {};
                        if (requestParameters.customerId !== undefined) {
                            queryParameters['customerId'] = requestParameters.customerId;
                        }
                        if (requestParameters.branchId !== undefined) {
                            queryParameters['branchId'] = requestParameters.branchId;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/retail/jobContracts",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.JobContractsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get job contracts for provided customer id and branch id
     */
    OrderApi.prototype.getJobContracts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJobContractsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Fetches a single order
     */
    OrderApi.prototype.getOrderRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling getOrder.');
                        }
                        queryParameters = {};
                        if (requestParameters.forceRefresh !== undefined) {
                            queryParameters['forceRefresh'] = requestParameters.forceRefresh;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_order"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/retail/orders/{orderId}".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.OrderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Fetches a single order
     */
    OrderApi.prototype.getOrder = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrderRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get user\'s orders
     */
    OrderApi.prototype.getOrdersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_order"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/user/orders",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.PagedUserOrdersResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get user\'s orders
     */
    OrderApi.prototype.getOrders = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrdersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get picking route for provided order number
     */
    OrderApi.prototype.getPickingRouteRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.orderNumber === null || requestParameters.orderNumber === undefined) {
                            throw new runtime.RequiredError('orderNumber', 'Required parameter requestParameters.orderNumber was null or undefined when calling getPickingRoute.');
                        }
                        queryParameters = {};
                        if (requestParameters.orderNumber !== undefined) {
                            queryParameters['orderNumber'] = requestParameters.orderNumber;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/retail/pickingRoute",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.PickingRouteResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get picking route for provided order number
     */
    OrderApi.prototype.getPickingRoute = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPickingRouteRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Prints documents (Picking Slip, Order Confirmation, or Delivery Docket) for an order based on the given details
     */
    OrderApi.prototype.printOrderDocumentsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/retail/printOrderDocuments",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.PrintOrderDocumentsRequestToJSON(requestParameters.printOrderDocumentsRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Prints documents (Picking Slip, Order Confirmation, or Delivery Docket) for an order based on the given details
     */
    OrderApi.prototype.printOrderDocuments = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.printOrderDocumentsRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Prints a document for a quote based on the given details
     */
    OrderApi.prototype.printQuoteDocumentRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/retail/printQuoteDocument",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.PrintQuoteDocumentRequestToJSON(requestParameters.printQuoteDocumentRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Prints a document for a quote based on the given details
     */
    OrderApi.prototype.printQuoteDocument = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.printQuoteDocumentRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * When an order fails, this endpoint is used to resolve the order
     */
    OrderApi.prototype.resolveFailedOrderRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling resolveFailedOrder.');
                        }
                        queryParameters = {};
                        if (requestParameters.printerAddress !== undefined) {
                            queryParameters['printerAddress'] = requestParameters.printerAddress;
                        }
                        if (requestParameters.retryOrder !== undefined) {
                            queryParameters['retryOrder'] = requestParameters.retryOrder;
                        }
                        if (requestParameters.manuallyProcessed !== undefined) {
                            queryParameters['manuallyProcessed'] = requestParameters.manuallyProcessed;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["write_user"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/retail/resolveFailedOrder/{orderId}".replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * When an order fails, this endpoint is used to resolve the order
     */
    OrderApi.prototype.resolveFailedOrder = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resolveFailedOrderRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Search all orders
     */
    OrderApi.prototype.searchOrdersRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.pageSize !== undefined) {
                            queryParameters['pageSize'] = requestParameters.pageSize;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_order"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/retail/orders/search",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.OrderSearchRequestToJSON(requestParameters.orderSearchRequest),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.PagedUserOrdersResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Search all orders
     */
    OrderApi.prototype.searchOrders = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchOrdersRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update an existing order
     */
    OrderApi.prototype.updateOrderRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, _a, _b, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling updateOrder.');
                        }
                        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
                            throw new runtime.RequiredError('orderId', 'Required parameter requestParameters.orderId was null or undefined when calling updateOrder.');
                        }
                        if (requestParameters.createOrder === null || requestParameters.createOrder === undefined) {
                            throw new runtime.RequiredError('createOrder', 'Required parameter requestParameters.createOrder was null or undefined when calling updateOrder.');
                        }
                        queryParameters = {};
                        if (requestParameters.transactionSuffixId !== undefined) {
                            queryParameters['transactionSuffixId'] = requestParameters.transactionSuffixId;
                        }
                        if (requestParameters.printerAddress !== undefined) {
                            queryParameters['printerAddress'] = requestParameters.printerAddress;
                        }
                        if (requestParameters.printDocket !== undefined) {
                            queryParameters['printDocket'] = requestParameters.printDocket;
                        }
                        if (requestParameters.printDocketWithPrice !== undefined) {
                            queryParameters['printDocketWithPrice'] = requestParameters.printDocketWithPrice;
                        }
                        if (requestParameters.printDocketWithRetailPrice !== undefined) {
                            queryParameters['printDocketWithRetailPrice'] = requestParameters.printDocketWithRetailPrice;
                        }
                        if (requestParameters.labelPrinterAddress !== undefined) {
                            queryParameters['labelPrinterAddress'] = requestParameters.labelPrinterAddress;
                        }
                        if (requestParameters.printOrderLabels !== undefined) {
                            queryParameters['printOrderLabels'] = requestParameters.printOrderLabels;
                        }
                        if (requestParameters.orderLabelQuantity !== undefined) {
                            queryParameters['orderLabelQuantity'] = requestParameters.orderLabelQuantity;
                        }
                        if (requestParameters.invoiceOrder !== undefined) {
                            queryParameters['invoiceOrder'] = requestParameters.invoiceOrder;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        // oauth required
                        _a = headerParameters;
                        _b = "Authorization";
                        return [4 /*yield*/, this.configuration.accessToken("OAuth2", ["read_order"])];
                    case 1:
                        // oauth required
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/retail/{customerId}/orders/{orderId}/update".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))).replace("{" + "orderId" + "}", encodeURIComponent(String(requestParameters.orderId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: models_1.CreateOrderToJSON(requestParameters.createOrder),
                        }, initOverrides)];
                    case 3:
                        response = _c.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.OrderFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update an existing order
     */
    OrderApi.prototype.updateOrder = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateOrderRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return OrderApi;
}(runtime.BaseAPI));
exports.OrderApi = OrderApi;
